import { FC } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from "@mui/material";

import {
  AllotmentPolicies,
  PrincipalInfoGT,
  StoragesTemplates,
} from "../../../../../redux/slices/grainTracker/grainTrackerTypes";
import { stylesGW } from "../../../grainWiseStylesMUIComponents";
import { selectedCriteria } from "../../../../../redux/slices/grainTracker/grainTracker";

type PrincipalInformationGrainTrackerParams = {
  t: (arg0: string) => string;
  storage: string | undefined;
  handleStorageId: (event: SelectChangeEvent) => void;
  storagesTemplates: StoragesTemplates | undefined;
  name: string;
  setNamePIGT: (principalInfoGT: PrincipalInfoGT, name: string) => void;
  principalInfoGT: PrincipalInfoGT;
  specie: any;
  handleChangeSpecies: (event: SelectChangeEvent) => void;
  addOptionByDefault: {
    id: number;
    slug: string;
    textIdLocale: string;
  }[];
  tonsCapacity: number | undefined;
  setTonsPIGT: (principalInfoGT: PrincipalInfoGT, tons: number) => void;
  editedLoading: boolean;
  AllotmentPolicies: AllotmentPolicies[];
  selectedCriteriaToDelete: string[];
};

export const PrincipalInformationGrainTracker: FC<
  PrincipalInformationGrainTrackerParams
> = ({
  t,
  storage,
  handleStorageId,
  storagesTemplates,
  name,
  setNamePIGT,
  principalInfoGT,
  specie,
  handleChangeSpecies,
  addOptionByDefault,
  tonsCapacity,
  setTonsPIGT,
  editedLoading,
  AllotmentPolicies,
  selectedCriteriaToDelete,
}) => {
  // Extracted and simplified the disabled logic for the species select
  const isSpeciesSelectDisabled =
    AllotmentPolicies.length > 0 &&
    !(
      selectedCriteriaToDelete.length > 0 &&
      selectedCriteriaToDelete.length === AllotmentPolicies.length
    );

  return (
    <FormControl sx={stylesGW.principalInformation.FormControl} fullWidth>
      <InputLabel>{`${t("Grain_tracker.type-label")} *`}</InputLabel>
      <Select
        required
        value={storage}
        label={t("Grain_tracker.type-label")}
        onChange={handleStorageId}
        disabled={editedLoading}
      >
        {storagesTemplates?.data.map((values) => {
          return (
            <MenuItem key={values.id} value={values.id}>
              {values.nameTextId.text}
            </MenuItem>
          );
        })}
      </Select>

      <TextField
        sx={stylesGW.principalInformation.FormControl}
        label={t("Grain_tracker.name-label")}
        placeholder={t("Grain_tracker.name-placeholder")}
        required
        value={name}
        disabled={editedLoading}
        onChange={(e: any) => setNamePIGT(principalInfoGT, e.target.value)}
      />
      <div className="specie-ton-container-graintracker">
        <Tooltip
          title={
            AllotmentPolicies.length > 0
              ? t("Grain_tracker.info_criteria_selected")
              : ""
          }
          arrow
          placement="top"
        >
          <FormControl
            sx={stylesGW.principalInformation.FormControlSpecieContainer}
            disabled={editedLoading}
          >
            <InputLabel>{`${t(
              "Grain_tracker.expected-species-label",
            )} *`}</InputLabel>
            <Select
              required
              value={specie}
              label={t("Grain_tracker.expected-species-label")}
              onChange={handleChangeSpecies}
              disabled={isSpeciesSelectDisabled}
            >
              {addOptionByDefault.map((values) => {
                if (values?.id === 0) {
                  return (
                    <MenuItem disabled key={values.id} value={values.id}>
                      {values.textIdLocale}
                    </MenuItem>
                  );
                } else {
                  return (
                    <MenuItem key={values?.id} value={values?.id}>
                      {values?.textIdLocale}
                    </MenuItem>
                  );
                }
              })}
            </Select>
          </FormControl>
        </Tooltip>

        <TextField
          sx={stylesGW.principalInformation.AvailableCapacityTextField}
          fullWidth
          InputLabelProps={{ shrink: true }}
          label={t("Grain_tracker.available-capacity-label")}
          type="number"
          placeholder={t("Grain_tracker.storage-unit")}
          InputProps={{ inputProps: { step: "any", min: 0, max: 1000000 } }}
          required
          variant="outlined"
          value={tonsCapacity ?? 0}
          disabled={editedLoading}
          onChange={(e) => {
            const value = parseFloat(e.currentTarget.value);
            const limitedValue = value > 1000000 ? 1000000 : value;
            setTonsPIGT(principalInfoGT, limitedValue);
          }}
        />
      </div>
    </FormControl>
  );
};
